import React from 'react';

//colors in classNames are not necessarily the html color with that name

export default function MapLegendKbdi(props) {
  const { title } = props;
  return (
      <table className="mapLegend-container" summary="Legend for point value markers on map">
        <tbody>
          <tr>
            <th colSpan="10">{title}</th>
          </tr>
          <tr>
            <td className="mapLegend-icon-container"><div className="mapLegend-icon mapLegend-icon-darkred"></div></td>
            <td className="mapLegend-value-container">&ge;700 to &le;800</td>
            <td className="mapLegend-icon-container"><div className="mapLegend-icon mapLegend-icon-orangered"></div></td>
            <td className="mapLegend-value-container">&ge;600 to &lt;700</td>
            <td className="mapLegend-icon-container"><div className="mapLegend-icon mapLegend-icon-gold"></div></td>
            <td className="mapLegend-value-container">&ge;400 to &lt;600</td>
            <td className="mapLegend-icon-container"><div className="mapLegend-icon mapLegend-icon-khaki"></div></td>
            <td className="mapLegend-value-container">&ge;200 to &lt;400</td>
            <td className="mapLegend-icon-container"><div className="mapLegend-icon mapLegend-icon-springgreen"></div></td>
            <td className="mapLegend-value-container">&ge;0 to &lt;200</td>
          </tr>
        </tbody>
      </table>
    );
}